import type { WorkflowKind } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Badge, Icon } from "@sagot/ui";

/** Customer-facing (the visitor sees its steps) or background (works behind the scenes): icon and words. */
export function KindBadge({ kind }: { kind: WorkflowKind }) {
  const { t } = useTranslation();
  return (
    <Badge tone={kind === "facing" ? "brand" : "neutral"} data-kind={kind}>
      <Icon name={kind === "facing" ? "message-square" : "zap"} className="size-3" />
      {t(`engage.workflows.kinds.${kind}`)}
    </Badge>
  );
}
